import { ClmmPoolUtil } from '@cetusprotocol/cetus-sui-clmm-sdk';
import { BN } from 'parrot-sui-sdk';
import { useMemo } from 'react';
export const useEstLiquidityAndCoinAmountFromOneAmounts = (
  lowerTick: number | undefined,
  upperTick: number | undefined,
  coinAmount: BN,
  isCoinA: boolean,
  roundUp: boolean,
  slippage: number,
  curSqrtPrice: BN | undefined,
) => {
  return useMemo(() => {
    if (
      !lowerTick ||
      !upperTick ||
      !curSqrtPrice ||
      coinAmount.eq(new BN(0)) ||
      curSqrtPrice.eq(new BN(0)) ||
      upperTick <= lowerTick
    )
      return;

    const liquidityInput = ClmmPoolUtil.estLiquidityAndcoinAmountFromOneAmounts(
      lowerTick,
      upperTick,
      coinAmount,
      isCoinA,
      roundUp,
      slippage,
      curSqrtPrice,
    );

    const amount_a = isCoinA ? coinAmount.toString() : liquidityInput.tokenMaxA.toString();
    const amount_b = isCoinA ? liquidityInput.tokenMaxB.toString() : coinAmount.toString();

    return {
      amount_a,
      amount_b,
      amount_a_max: liquidityInput.tokenMaxA.toString(),
      amount_b_max: liquidityInput.tokenMaxB.toString(),
    };
  }, [lowerTick, upperTick, curSqrtPrice, coinAmount, isCoinA, slippage, roundUp]);
};
